// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { __assign } from "tslib";
import { getTracer } from "@azure/core-tracing";
import { SpanKind } from "@opentelemetry/api";
/**
 * Creates a span using the global tracer.
 * @param name The name of the operation being performed.
 * @param tracingOptions The options for the underlying http request.
 */
export function createSpan(operationName, tracingOptions) {
    if (tracingOptions === void 0) { tracingOptions = {}; }
    var tracer = getTracer();
    var spanOptions = __assign(__assign({}, tracingOptions.spanOptions), { kind: SpanKind.INTERNAL });
    var span = tracer.startSpan("Azure.Storage.Blob." + operationName, spanOptions);
    span.setAttribute("az.namespace", "Microsoft.Storage");
    var newOptions = tracingOptions.spanOptions || {};
    if (span.isRecording()) {
        newOptions = __assign(__assign({}, tracingOptions.spanOptions), { parent: span.context(), attributes: __assign(__assign({}, spanOptions.attributes), { "az.namespace": "Microsoft.Storage" }) });
    }
    return {
        span: span,
        spanOptions: newOptions
    };
}
//# sourceMappingURL=tracing.js.map